import React, {PureComponent} from "react";
import Facebook from "../../ui/facebook";
import Twitter from "../../ui/twitter";
import Linkedin from "../../ui/linkedin";
import Messenger from "../../ui/messenger";
import Whatsapp from "../../ui/whatsapp";
import Tiktok from "../../ui/tiktok";
import InstagramIcon from 'mdi-react/InstagramIcon';
import PinterestIcon from 'mdi-react/PinterestIcon';
import SnapchatIcon from 'mdi-react/SnapchatIcon';
import WhatsappIcon from 'mdi-react/WhatsappIcon';
import YoutubeIcon from 'mdi-react/YoutubeIcon';
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import "./AmbassadorHeader.scss";

class AmbassadorHeader extends PureComponent {

    getSocialNetworks = (ambassador, dataKey) => {
        const array = [];
        if (ambassador && ambassador.data && (dataKey && ambassador.data[dataKey])) {
            const socialHandles = ambassador.data[dataKey];
            Object.entries(socialHandles).forEach(s => {
                let objectResponse = {};
                objectResponse[s[0]] = s[1];
                if (s[1] !== "")
                    array.push(objectResponse);
            });

        }
        return array;
    }
    cleanName(networkName){
        if(networkName.indexOf("_chat") !== -1){
            return networkName.replace("_chat", "")
        }else{
            return networkName.replace("_url", "")
        }
    }
    getSocialIcon(socialName){
        switch (socialName) {
            case "instagram":
                return <InstagramIcon color={"#000000"}/>;
            case "twitter":
                return <Twitter color={"#000000"} />;
            case "facebook":
                return <Facebook color={"#000000"}/>;
            case "pinterest":
                return <PinterestIcon color={"#000000"}/>;
            case "snapchat":
                return <SnapchatIcon color={"#000000"}/>;
            case "tiktok":
                return <Tiktok/>;
            case "whatsapp":
                return <WhatsappIcon color={"#000000"}/>;
            case "linkedin":
                return <Linkedin/>;
            case "youtube":
                return <YoutubeIcon size={30} color={"#000000"} />
            case "whatsapp_messaging":
                return <Whatsapp/>;
            case "facebook_messaging":
                return <Messenger/>;
        }
    }
    fixName(networkName){
        if(networkName === "whatsapp")
            return "WhatsApp";
        else if(networkName === "tiktok")
            return "TikTok";
        else if(networkName === "linkedin")
            return "LinkedIn";
        else if(networkName === "youtube")
            return "YouTube";
        return networkName;
    }
    checkWhatsApp(url){
        const whatsBaseUrl = "https://wa.me/";
        url = url.replace("+","");
        return (url.indexOf(whatsBaseUrl) == -1) ? whatsBaseUrl+url : url;
    }
    renderSocials = (value, index) => {
        const fieldName = Object.keys(value)[0];
        const networkName = this.cleanName(fieldName);
        const link = networkName === "whatsapp" ? this.checkWhatsApp(value[fieldName]) : value[fieldName];
        return <a href={link} key={index}  target={"_blank"}>
            <span className={"icon "+networkName}>
                {this.getSocialIcon(networkName)}
            </span>
            <span className={"name"}>
                {this.fixName(networkName)}
            </span>
        </a>
    }

    renderMessagingIcons(item,index){
      const fieldName = Object.keys(item)[0];
      const link = fieldName === "whatsapp" ? this.checkWhatsApp(item[fieldName]) : item[fieldName];
      return <a href={link} key={index}  target={"_blank"}>
              {this.getSocialIcon(fieldName+"_messaging")}
      </a>
    }

    render() {
        const ambassador = TVSite.ambassadorData;
        const storefront_details = AmbassadorHelper.getStoreFrontDetails(ambassador);
        const displayName = AmbassadorHelper.getDisplayName(ambassador);
        const textWelcome1 = (storefront_details && storefront_details.welcome_text_1)
            ? storefront_details.welcome_text_1 : "";
        const textWelcome2 = (storefront_details && storefront_details.welcome_text_2)
            ? storefront_details.welcome_text_2 : "";
        const backgroundCover = AmbassadorHelper.getAmbassadorCover(ambassador);
        const socials = this.getSocialNetworks(ambassador, "social_handles");
        const messaging = this.getSocialNetworks(ambassador, "messaging");
        return <div className={"lines"}>
            <div className={"ambassador-header"}>
                <div className={"ambassador-header-info"}
                     style={{backgroundImage: `url(${backgroundCover})`}}>
                    <div className={"ambassador-header-info-profile-image"}
                         style={{backgroundImage: `url(${AmbassadorHelper.getAmbassadorPhoto(ambassador)})`}}>
                    </div>
                </div>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-12 ambassador-header-details"}>
                            <div className={"ambassador-header-info-profile-name text-center"}>
                                {displayName}
                                {
                                    messaging ? messaging.map(this.renderMessagingIcons.bind(this)) : null
                                }
                            </div>
                            <div className={"ambassador-header-info-profile-introduction"}>
                                <div>
                                    {textWelcome1}
                                </div>
                                <div>
                                    {textWelcome2}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className={"storefront-socials"}>
                            {
                                socials.map(this.renderSocials)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    }
}

export default AmbassadorHeader;